import React, { Fragment } from 'react';
import { CmsEntities } from 'client/data/models/cms';
import { DEFAULT_CONTENT } from 'client/data/cms/content';
import { ScrollLink } from 'site-modules/shared/components/scroll-link/scroll-link';

export function InlineSubnav({ entry }) {
  const links = entry.links();

  return links.length ? (
    <div className="inline-subnav mb-1">
      <span className="size-16 text-gray-darker">Jump to segment:</span>
      {links.map(({ href, title }, ind) => (
        <Fragment key={href}>
          {' '}
          <ScrollLink to={href} className="size-16 text-primary-darker">
            {title}
          </ScrollLink>{' '}
          {ind !== links.length - 1 && '|'}
        </Fragment>
      ))}
    </div>
  ) : null;
}

InlineSubnav.propTypes = {
  entry: CmsEntities.Content,
};

InlineSubnav.defaultProps = {
  entry: DEFAULT_CONTENT,
};
